import { render, staticRenderFns } from "./TaskActivityLogs.vue?vue&type=template&id=59e6c2a6&scoped=true"
import script from "./TaskActivityLogs.vue?vue&type=script&lang=js"
export * from "./TaskActivityLogs.vue?vue&type=script&lang=js"
import style0 from "./TaskActivityLogs.vue?vue&type=style&index=0&id=59e6c2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6c2a6",
  null
  
)

export default component.exports